import React, { useEffect, useRef, useState } from "react";

import { Badge, Modal, Table } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from "react-router-dom";
import DoneGreen from "../assets/doneGreen.svg";
import FilterIcon from "../assets/filterIcon.png";
import pdficon from "../assets/pdficon.png";
import Person from "../assets/person.png";
import Search from "../assets/search.png";
import TimeTable from "../assets/time_table.svg";
import {
  Download,
  CheckCircle2,
  AlertCircle,
  Clock,
  Car,
  Edit,
  FileText,
  ShieldCheck,
  ClipboardEdit,
  ParkingMeter,
  CalendarCheck,
  Eye,
  Key,
  ArchiveRestore,
  File,
} from "lucide-react";
import { Button } from "@mui/material";

import {
  APL_LINK,
  drop_car_api,
  filter_booking_data,
  get_all_booking_data,
  get_booking_data,
  update_booking_car_in_review,
  get_car_transaction_details,
  server_post_data,
  submit_accept_reject_booking,
  submit_update_insurance_data,
  get_all_cars_without_booking,
  cancel_booking_admin,
  change_payment_cycle,
  payment_data_api,
  get_booking_ipass_data,
  upload_mvr_pdf,
  upload_driving_licence_image,
  update_show_hide_status,
  upload_mvr_image,
} from "../ServiceConnection/serviceconnection.js";
import {
  ViewStaffPagesText,
  options_search,
  status_search,
} from "./../CommonJquery/WebsiteText";
import Loader from "./Loader.js";

import { CalendarClock, IdCard } from "lucide-react";
import {
  check_vaild_save,
  combiled_form_data,
  computeTodayDate,
  computeplussevendays,
  mondayDayYearFormat,
  handleAlphabetsNumberWithoutSpaceChange,
  handleAphabetsChange,
  handleEmailChange,
  handleError,
  handleIaphabetnumberChange,
  handleNumbersChange,
  handleSuccess,
  formatToYYYYMMDD,
  formatBookingId,
} from "../CommonJquery/CommonJquery.js";
import InsuranceForm from "./InsuranceForm";
import ViewAgreeMentForm from "./ViewAgreeMentForm.js";
import UpdatePolicyModal from "./UpdatePolicyModal.js";
import ReviewModal from "./ReviewModal.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CarActionModalPopup from "./CarActionModalPopup.js";
import SwitchIPassModal from "./SwitchIPassModal.js";
import UserIconOrenge from "../assets/UserIconOrenge.svg";
import MVRDownload from "./MVRDownload.js";
import DrivingLicenseDownload from "./DLDownload.js";
const ReservationHistory = ({ sharedValue }) => {
  let flag = "1";
  const navigate = useNavigate();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  const [SelectedData, setSelectedData] = useState([]);
  const [AgentData, setAgentData] = useState([]);
  const [SelectedCycle, setSelectedCycle] = useState("Daily");
  const [uploadedDamageImagesfinal, setUploadedDamageImages] = useState([]);

  const [activeSlotsTime, setActiveSlotsTime] = useState(0);
  const [activeAgree, setActiveAgree] = useState(true);
  const [activeAgree1, setActiveAgree1] = useState(true);
  const [activeAgree2, setActiveAgree2] = useState(true);
  const [transactionmodal, settransactionmodal] = useState(false);
  const [PaymentCycleModal, setPaymentCycleModal] = useState(false);
  const [PaymentMode, setPaymentMode] = useState("Cash");
  const [duescontnt, setduescontnt] = useState(
    "Are you sure you want to Accept this booking, Driver has previous outstanding dues!",
  );
  const [PaymentType, setPaymentType] = useState(1);
  const [checklistError, setChecklistError] = useState(false);
  const [claimError, setClaimError] = useState(false);
  const [SignImg, SetSignImg] = useState();
  const [DringImg, SetDringImg] = useState();
  const [CarImgPath, SetCarImgPath] = useState();

  const [carIpass, setcarIpass] = useState([]);
  const [totalIpass, setTotalIpass] = useState([]);

  const [ipasscarData, setipasscardata] = useState();
  let formattedSevenDaysAgo = computeplussevendays();
  let formattedToday = computeTodayDate();
  const selectedStatus = localStorage.getItem("selectedStatusFilter");

  if (sharedValue !== null) {
    formattedToday = sharedValue;
    formattedSevenDaysAgo = sharedValue;
    flag = "2";
  }
  const [flagData, setflagData] = useState("1");
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(formattedSevenDaysAgo);
  const [endDate, setEndDate] = useState(formattedToday);
  const [modalShow, setModalShow] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [Moneyiconleft, setMoneyiconleft] = useState(null);
  const [Moneyiconright, setMoneyiconright] = useState(null);
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [downloadForm, SetDownloadForm] = useState();
  const [downloadForm2, SetDownloadForm2] = useState();
  const [selectedValue, setSelectedValue] = useState("Name");
  const [PaymentCycleModalData, setPaymentCycleModalData] = useState("");
  const [statusValue, setstatusValue] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [SearchFilter, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [showIpassModal, setShowIpassModal] = useState(false);

  // Dumy Data for ipasss modal design
  const dummyCurrentIPass = {
    ipass_id: "IPASS-001",
    car_detail: {
      car_id: 1,
      car_name: "Toyota Camry",
    },
  };

  const dummyAvailableIPasses = [
    {
      primary_id: 1,
      ipass_id: "IPASS-002",
      ipass_date: "2023-01-15",
    },
    {
      primary_id: 2,
      ipass_id: "IPASS-003",
      ipass_date: "2023-02-20",
    },
    {
      primary_id: 3,
      ipass_id: "IPASS-004",
      ipass_date: "2023-03-10",
    },
  ];

  const dummyCarData = [
    {
      primary_id: 1,
      car_name: "Toyota Camry",
    },
    {
      primary_id: 2,
      car_name: "Honda Accord",
    },
  ];
  // Handle modal open
  const handleOpenIpassModal = async (option) => {
    setipasscardata(option);
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("car_id", option?.car_id);
    await server_post_data(get_booking_ipass_data, fd)
      .then((Response) => {
        // //console.log("lllnnncData", Response);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setcarIpass(Response.data.message.car_ipass);
          setTotalIpass(Response.data.message.ipass_data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    setShowIpassModal(true);
  };

  // Handle modal close
  const handleCloseIpassModal = () => {
    setShowIpassModal(false);
  };

  // Handle switch completion (callback for modal)
  const handleSwitchComplete = (currentIPass, selectedIPass, switchNotes) => {
    console.log("Switch completed:", {
      currentIPass,
      selectedIPass,
      switchNotes,
    });
    // Add logic to update state or call an API
  };
  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const filteredSearchFilter = SearchFilter.filter(
    (data) => data.show_hide_status !== "1",
  );
  const currentItems = filteredSearchFilter
    ? filteredSearchFilter.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = filteredSearchFilter
    ? Math.ceil(filteredSearchFilter.length / itemsPerPage)
    : 0;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>,
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>,
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>,
    );

    return buttons;
  };

  const handleuploadMvrFile = async (e, booking_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", booking_id);
    fd.append("mvr_pdf", e.target.files[0]);
    await server_post_data(upload_mvr_pdf, fd)
      .then((Response) => {
        // //console.log("lllnnncData", Response);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(startDate, endDate, flagData, "0");
          setModalShow(true);
          setModalShow1(false);
          setModalShow2(false);
          setModalShow3(false);
          setActiveAgree(true);
        }
        setshowLoaderAdmin(false);
        setModalShow(true);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    // setShowIpassModal(true);
  };

  const handleuploadDLFile = async (e, booking_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", booking_id);
    fd.append("driving_licence_image", e.target.files[0]);
    await server_post_data(upload_driving_licence_image, fd)
      .then((Response) => {
        // //console.log("lllnnncData", Response);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(startDate, endDate, flagData, "0");
          setModalShow(true);
          setModalShow1(false);
          setModalShow2(false);
          setModalShow3(false);
          setActiveAgree(true);
        }
        setshowLoaderAdmin(false);
        setModalShow(true);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    // setShowIpassModal(true);
  };

  const handleuploadDLFileMVR = async (data, booking_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", booking_id);
    fd.append("DamgeImage", JSON.stringify(uploadedDamageImagesfinal));
    await server_post_data(upload_mvr_image, fd)
      .then((Response) => {
        // //console.log("lllnnncData", Response);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(startDate, endDate, flagData, "0");
          setModalShow(true);
          setModalShow1(false);
          setModalShow2(false);
          setModalShow3(false);
          setActiveAgree(true);
        }
        setshowLoaderAdmin(false);
        setSelectedData({
          show_msg: "Do you want to Approve this Application",
          button_name: "Accept",
          button_name_next: "Reject",
          step_click: "1",
          ...data,
        });
        setModalShow(true);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    // setShowIpassModal(true);
  };

  const openModal = (item) => {
    // //console.log("Opening modal with item:", item);
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  const handleClose = () => {
    // toggleActiveAgree1(true)
    setModalShow(false);
    setModalShow1(false);
    setModalShow2(false);
    setModalShow3(false);
    setActiveAgree(true);
  };
  const handleCloseTranstionModal = () => {
    settransactionmodal(false);
  };
  const handleClosePaymentCycleModal = () => {
    setPaymentCycleModal(false);
  };

  const toggleActiveAgree = (value) => {
    setActiveAgree(value);
  };

  const openCustomDatePicker = (customDatePickerInput_id) => {
    document.getElementById(customDatePickerInput_id).focus();
  };

  const handleChange2 = (event) => {
    setPaymentMode(event.target.value);
  };
  const handleChange33 = (event) => {
    setPaymentType(event.target.value);
  };

  const handleShow = (data_call, click_type) => {
    if (click_type === "review") {
      setSelectedData({
        show_msg: "Do you want to Approve this Application",
        button_name: "Accept",
        button_name_next: "Reject",
        step_click: "1",
        ...data_call,
      });
      setModalShow(true);
    } else if (click_type === "policy") {
      setSelectedData({
        show_msg: "Do you want to Update this Application",
        button_name: "Submit",
        button_name_next: "Close",
        step_click: "2",
        ...data_call,
      });
      setModalShow1(true);
    } else if (click_type === "pickup") {
      setSelectedData({
        show_msg: "Do you want to handover the vehicle",
        button_name: "Handover",
        button_name_next: "Close",
        step_click: "3",
        ...data_call,
      });
      setModalShow2(true);
    } else if (click_type === "drop") {
      setSelectedData({
        show_msg: "Do you want to Update this Application",
        button_name: "Submit",
        button_name_next: "Close",
        step_click: "4",
        ...data_call,
      });
      setModalShow3(true);
    } else if (click_type === "payment") {
      setSelectedData({
        show_msg: "Do you want to Update this Application",
        button_name: "Submit",
        button_name_next: "Close",
        step_click: "5",
        ...data_call,
      });
      setModalShow2(true);
    }
  };

  const handleActiveDeactive = (activeAgree) => {
    // Check if at least one checklist item is selected
    if (SelectedData.step_click === "4") {
      if (checklistItems.length > 0 && selectedItems.length === 0) {
        setChecklistError(true);
        return;
      } else {
        setChecklistError(false);
      }

      // Check if claim is selected
      if (selectedOption === "") {
        setClaimError(true);
        return;
      } else {
        setClaimError(false);
      }
    }
    // Proceed with submitting data if there are no errors
    if (SelectedData.step_click === "1") {
      if (activeAgree == true || activeAgree == false) {
        handleSaveChangesdynamic(
          "accept_reject_data",
          submit_accept_reject_booking,
        );
      }
    } else if (SelectedData.step_click === "2") {
      if (activeAgree1 == true || activeAgree1 == false) {
        handleSaveChangesdynamic(
          "update_policy_data",
          submit_update_insurance_data,
        );
      }
    } else if (SelectedData.step_click === "3") {
      if (activeAgree == true || activeAgree == false) {
        handleSaveChangesdynamic("update_pickup_data", payment_data_api);
      }
    } else if (SelectedData.step_click === "4") {
      handleSaveChangesdynamic("Drop_car_data", drop_car_api);
    }
  };

  const [selectedItems, setSelectedItems] = useState([]);

  const checklistItems = [
    "Insurance",
    "Registration",
    "Inspection",
    "2nd Key Check",
  ];

  const handleCheckboxChange = (item) => {
    setSelectedItems((prevState) =>
      prevState.includes(item)
        ? prevState.filter((i) => i !== item)
        : [...prevState, item],
    );
    if (selectedItems.length > 0 || !selectedItems.includes(item)) {
      setChecklistError(false);
    }
  };

  const formattedOutput = selectedItems.join("~@~");

  const [selectedOption, setSelectedOption] = useState("");
  const [claimReason, setClaimReason] = useState("");
  // Handle radio button changes
  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);

    if (event.target.value !== "Yes, Claims (See additional notes)") {
      setClaimReason("");
    }
  };

  const handleReasonChange = (event) => {
    setClaimReason(event.target.value);
    if (event.target.value !== "") {
      setClaimError(false);
    }

    if (event.target.value !== "Yes, Claims (See additional notes)") {
      setClaimReason("");
    }
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = true;
    if (form_data !== null) {
      vaild_data = check_vaild_save(form_data);
    }
    if (!activeAgree || vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = new FormData();
      if (form_data !== null) {
        fd_from = combiled_form_data(form_data, null);
      }
      fd_from.append("DamgeImage", JSON.stringify(uploadedDamageImagesfinal));
      if (
        SelectedData &&
        SelectedData.step_click &&
        SelectedData.step_click === "1"
      ) {
        fd_from.append("primary_id", SelectedData.primary_id);
        if (activeAgree) {
          fd_from.append("step_for_booking", 1);
        } else {
          fd_from.append("step_for_booking", 10);
        }
        // console.log()
        // fd_from.append("agent_id", AgentData[activeSlotsTime].primary_id);
      }

      if (
        SelectedData &&
        SelectedData.step_click &&
        SelectedData.step_click === "2"
      ) {
        fd_from.append("primary_id", SelectedData.primary_id);
        if (activeAgree) {
          fd_from.append("step_for_booking", 2);
        } else {
          fd_from.append("step_for_booking", 10);
        }
        fd_from.append(
          "car_id",
          SelectedData.car_data && SelectedData.car_data.length > 0
            ? SelectedData.car_data[0].primary_id
            : "0",
        );
      }
      if (
        SelectedData &&
        SelectedData.step_click &&
        SelectedData.step_click === "3"
      ) {
        fd_from.append("primary_id", SelectedData.primary_id);
        fd_from.append("user_id", SelectedData.user_id);
        fd_from.append(
          "car_id",
          SelectedData.car_data && SelectedData.car_data.length > 0
            ? SelectedData.car_data[0].primary_id
            : "0",
        );
      }
      if (
        SelectedData &&
        SelectedData.step_click &&
        SelectedData.step_click === "4"
      ) {
        fd_from.append("primary_id", SelectedData.primary_id);
        fd_from.append("contract_id", SelectedData.contract_id);
        fd_from.append("Check_List", selectedItems.join("~@~"));
        fd_from.append("Claims", selectedOption);
        fd_from.append("reasion", claimReason);
        // if (activeAgree) {
        //   fd_from.append("step_for_booking", 3);
        // } else {
        //   fd_from.append("step_for_booking", 10);
        // }
        fd_from.append(
          "car_id",
          SelectedData.car_data && SelectedData.car_data.length > 0
            ? SelectedData.car_data[0].primary_id
            : "0",
        );
      }
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            if (
              SelectedData &&
              SelectedData.step_click &&
              SelectedData.step_click === "1"
            ) {
              if (Response.data.Dues) {
                setduescontnt(Response.data.message);
                setDueModal(true);
              } else {
                handleError(Response.data.message);
              }
            } else {
              handleError(Response.data.message);
            }
          } else {
            handleSuccess(Response.data.message);
            handleClose();
            const call_id = "0";
            master_data_get(startDate, endDate, flagData, call_id);
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
          handleError("network");
        });
    }
  };

  const handleSelect = (event) => {
    setSelectedValue(event.target.value); // Update the selected value when an option is selected
  };
  const HandlePaymentCycleModal = (option) => {
    setPaymentCycleModal(true);
    setPaymentCycleModalData(option);
    setSelectedCycle(option.payment_day_week == "1" ? "Daily" : "Weekly"); // Update the selected value when an option is selected
  };
  const handleStatusSelect = (event) => {
    master_data_get_filter(event.target.value);
    setstatusValue(event.target.value);
  };

  const search_data = () => {
    flag = "2";
    const call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  };

  // useEffect(() => {
  //   const call_id = "0";
  //   master_data_get(startDate, endDate, flagData, call_id);
  // }, []);

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("end_date", formatToYYYYMMDD(end_date));
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    // fd.append("filter_booking_data", statusValue);
    fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_all_booking_data, fd)
      .then((Response) => {
        // //console.log("Show_data", Response.data.message);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          seteditStaffData(Response.data.message.data_booking);
          console.log(Response.data.message.data_booking);
          setfilteredData(Response.data.message.data_booking);
          setFilteredData(Response.data.message.data_booking);
          setMoneyiconright(Response.data.message.data_money_right);
          setMoneyiconleft(Response.data.message.data_money_left);
          setAgentData(Response.data.message.data_agent_list);
          SetSignImg(APL_LINK + Response.data.message.data_signature_image);
          // SetSignImg(APL_LINK + Response.data.message.driving_licence_image_full);
          console.log(
            APL_LINK + Response.data.message.driving_licence_image_full,
          );
          SetDringImg(APL_LINK + Response.data.message.data_licence_image);
          SetCarImgPath(APL_LINK + Response.data.message.data_other_image);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // //console.log("car_img_path", CarImgPath);

  // useEffect(()=>{
  //   master_data_get_filter()
  // },[statusValue])

  const master_data_get_filter = async (data) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("status", data);
    // fd.append("status", statusValue);
    await server_post_data(filter_booking_data, fd)
      .then((Response) => {
        // //console.log("lllnnncData", Response);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          seteditStaffData(Response.data.message.data_booking);
          console.log(
            "Response.data.message.data_booking",
            Response.data.message.data_booking,
          );
          setfilteredData(Response.data.message.data_booking);
          setFilteredData(Response.data.message.data_booking); // Update SearchFilter state
          setCurrentPage(1);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const master_data_get_transaction = async (book_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("booking_id", book_id);
    await server_post_data(get_car_transaction_details, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setTransactionData(Response.data.message.transaction_deatils);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    // Filter table data based on search value
    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
    setFilteredData(filteredDatashow); // Update SearchFilter state
    setCurrentPage(1); // Reset to first page when search changes
  };

  const childRef = useRef();
  const childRef2 = useRef();
  const childRef4 = useRef();
  const childRef3 = useRef();
  const [DamageImg, setDamageImg] = useState([]);
  const [DlImg, setDlImg] = useState();

  const triggerPrint = () => {
    childRef.current.handlePrint();
  };

  // const triggerDownloadPDF = (option) => {
  //   SetDownloadForm(option);
  const triggerDownloadPDF = (option) => {
    SetDownloadForm(option);
    console.log("option", option);
    setTimeout(() => {
      if (childRef.current) {
        childRef.current.handleDownloadPDF();
      }
    }, 100); // slight delay to ensure state update
  };
  const triggerDownloadMVR = (SelectedData, option) => {
    SetDownloadForm(SelectedData);
    setDamageImg(option);
    console.log("option", option);
    setTimeout(() => {
      if (childRef3.current) {
        childRef3.current.handleDownloadPDF();
      }
    }, 100); // slight delay to ensure state update
  };
  const triggerDownloadDL = (SelectedData, option) => {
    SetDownloadForm(SelectedData);
    setDlImg(option);
    console.log("option", SelectedData);
    setTimeout(() => {
      if (childRef4.current) {
        childRef4.current.handleDownloadPDF();
      }
    }, 100); // slight delay to ensure state update
  };

  // };

  const triggerDownloadPDF2 = async (option) => {
    // //console.log("hit not first time");
    // SetDownloadForm2(option);
    const fd = new FormData();
    fd.append("booking_id", option.primary_id);
    await server_post_data(get_booking_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          // //console.log("late response");
          // console.log("Response.data.message.data", Response.data.message.data);
          SetDownloadForm2(Response.data.message.data);
          SetSignImg(APL_LINK + Response.data.message.image_link_signature);
          if (childRef2.current) {
            childRef2.current.handleDownloadPDF();
          }
        }
      })
      .catch((error) => {
        // handleError("network");
        console.log(error);
      });
  };
  useEffect(() => {
    if (selectedStatus) {
      // //console.log("Found status in localStorage:", selectedStatus);
      master_data_get_filter(selectedStatus);
      // Update the state directly instead of manipulating DOM
      setstatusValue(selectedStatus);
      localStorage.removeItem("selectedStatusFilter");
    } else {
      // Only do the initial data load if there's no status filter
      const call_id = "0";
      master_data_get(startDate, endDate, flagData, call_id);
    }
  }, []); // Empty dependency array for component mount

  // Add a new useEffect that watches for changes to statusValue
  useEffect(() => {
    // Skip the initial render (when statusValue is empty string)
    if (statusValue !== "") {
      master_data_get_filter(statusValue);
    }
  }, [statusValue]);

  const handleNavigate = (id) => {
    navigate(`/ViewMaintenance/${id}`);
  };

  const handleNavigateEditPage = (id, option) => {
    navigate(`/Edit_application/${id}`, { state: { option: option } });
  };
  const handleNavigateViewPage = (path, option) => {
    navigate(path, { state: { option, CarImgPath } });
  };

  const getStatusBadge = (booking) => {
    let dayweek = "Day";
    if (booking.payment_day_week === 2) {
      dayweek = "Week";
    }
    ///payment_cycle_switch
    const { step_for_booking, fill_aggriment_status, payment_cycle_switch } =
      booking;
    console.log(
      step_for_booking,
      fill_aggriment_status,
      payment_cycle_switch,
      dayweek,
    );
    switch (step_for_booking) {
      case "0":
        return (
          <div className="status-badge status-new">
            <Clock size={16} className="status-icon" />
            <span>New</span>
          </div>
        );
      case "1":
        return (
          <div className="status-badge status-inprogress">
            <Clock size={16} className="status-icon" />
            <span>InProgress</span>
          </div>
        );
      case "2":
        return fill_aggriment_status == "0" ? (
          <div className="status-badge status-not-signed">
            <AlertCircle size={16} className="status-icon" />
            <span>Agreement not signed</span>
          </div>
        ) : (
          <div className="status-badge status-signed">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Agreement signed</span>
          </div>
        );
      case "3":
        return (
          <div className="status-badge status-ready">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Ready for Pickup</span>
          </div>
        );
      case "4":
        return (
          <>
            <div className="status-badge status-ongoing mb-0">
              <Car size={16} className="status-icon" />
              <span>OnGoing</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        );
      case "5":
        return payment_cycle_switch == "1" ? (
          <>
            <div className="status-badge status-rejected mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Payment Cycle Switch</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        ) : payment_cycle_switch === "2" ? (
          <>
            <div className="status-badge status-rejected mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Ipass Switch</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        ) : payment_cycle_switch === "3" ? (
          <>
            <div className="status-badge status-rejected mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Car Switch</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        ) : payment_cycle_switch === "4" ? (
          <>
            <div className="status-badge status-rejected mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Drop After Repo</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="status-badge status-completed mb-0">
              <CheckCircle2 size={16} className="status-icon" />
              <span>Completed</span>
            </div>
            <div className="status-badge mb-0">
              <span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--medium-text)",
                  }}
                >
                  Payment Cycle:
                </span>{" "}
                {dayweek}
              </span>
            </div>
          </>
        );
      case "6":
        return (
          <div className="status-badge status-ongoing">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Car Switch Ongoing</span>
          </div>
        );
      case "7":
        return (
          <div className="status-badge status-rejected">
            <CheckCircle2 size={16} className="status-icon" />
            <span>Repossessed</span>
          </div>
        );
      case "9":
        return (
          <div className="status-badge status-rejected">
            <AlertCircle size={16} className="status-icon" />
            <span>Cancelled</span>
          </div>
        );
      case "10":
        return (
          <div className="status-badge status-rejected">
            <AlertCircle size={16} className="status-icon" />
            <span>Rejected</span>
          </div>
        );
      case "11":
        return (
          <div className="status-badge status-rejected">
            <AlertCircle size={16} className="status-icon" />
            <span>Canceled</span>
          </div>
        );
      default:
        return (
          <div className="status-badge">
            <Clock size={16} className="status-icon" />
            <span>Unknown</span>
          </div>
        );
    }
  };
  const handleDateChange = (date) => {
    setStartDate(date);
  };
  // console.log('SelectedCycle',SelectedCycle)
  const handleConfirm = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", PaymentCycleModalData.primary_id);
    fd.append("daily_weekly", SelectedCycle === "Daily" ? "1" : "2");
    try {
      const Response = await server_post_data(change_payment_cycle, fd);
      if (Response.data.error) {
        handleError(Response.data.message);
      } else {
        handleSuccess(Response.data.message);
        setPaymentCycleModal(false);
        // Ensure master_data_get is called with the correct parameters;
        await master_data_get(startDate, endDate, flagData, "0");
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  const [avaliblecar, setavaliblecar] = useState();

  useEffect(() => {
    get_avalible_cars();
  }, []);
  const get_avalible_cars = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    await server_post_data(get_all_cars_without_booking, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log(Response.data.message.car_data);
          setavaliblecar(Response.data.message.car_data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    // setShowIpassModal(true);
  };
  const [showModal, setShowModal] = useState(false);
  const [showModalArchive, setShowModalArchive] = useState(false);
  const handlecancelbooking = async (id) => {
    setshowLoaderAdmin(true);
    console.log(id);
    const fd = new FormData();
    fd.append("booking_id", id);
    await server_post_data(cancel_booking_admin, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          // console.log(Response.data.message.car_data);
          // setavaliblecar(Response.data.message.car_data)
          master_data_get(startDate, endDate, flagData, "0");
          setShowModal(false);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    // setShowIpassModal(true);
  };

  const handleArchivebooking = async (id, state) => {
    setshowLoaderAdmin(true);
    console.log(id);
    const fd = new FormData();
    fd.append("call_id", id);
    if (state == "0") {
      fd.append("show_hide", 1);
    } else {
      fd.append("show_hide", 0);
    }
    await server_post_data(update_show_hide_status, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          // console.log(Response.data.message.car_data);
          // setavaliblecar(Response.data.message.car_data)
          master_data_get(startDate, endDate, flagData, "0");
          setShowModalArchive(false);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    // setShowIpassModal(true);
  };

  const handleArchivebooking2 = async (id, state) => {
    return;
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("primary_id", SelectedData.primary_id);
    fd.append("anyway_success", 1);
    if (activeAgree) {
      fd.append("step_for_booking", 1);
    } else {
      fd.append("step_for_booking", 10);
    }
    await server_post_data(update_show_hide_status, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          // console.log(Response.data.message.car_data);
          // setavaliblecar(Response.data.message.car_data)
          master_data_get(startDate, endDate, flagData, "0");
          setShowModalArchive(false);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    // setShowIpassModal(true);
  };

  const [id, setID] = useState(null);
  const [idArchive, setIDArchive] = useState(null);
  const [archiveState, setArchiveState] = useState(null);
  const [dueModal, setDueModal] = useState(null);
  const cancelToggleStatus = () => {
    setShowModal(false);
    setShowModalArchive(false);
    setDueModal(false);
  };

  const handleModalSHowCancel = (id) => {
    setShowModal(true);
    setID(id);
  };

  const handleModalSHowArchive = (id, state) => {
    setShowModalArchive(true);
    setIDArchive(id);
    setArchiveState(state);
  };

  function formatTimeTo24Hour(timeString) {
    if (!timeString) return "-";

    const [hourStr, minuteStr] = timeString.split(":");
    return `${hourStr}:${minuteStr}`;
  }
  return (
    <>
      {showLoaderAdmin && <Loader />}
      <div className="downLoad_PrintEnqury ">
        <InsuranceForm
          ref={childRef}
          downloadForm={downloadForm}
          SignImg={SignImg}
          DringImg={DringImg}
        />
      </div>
      <div className="downLoad_PrintEnqury">
        <MVRDownload
          ref={childRef3}
          downloadForm={downloadForm}
          SignImg={SignImg}
          DringImg={DringImg}
          DamageImg={DamageImg}
        />
      </div>
      <div className="downLoad_PrintEnqury ">
        <ViewAgreeMentForm
          ref={childRef2}
          downloadForm2={downloadForm2}
          SignImg={SignImg}
          DringImg={DringImg}
        />
      </div>
      <div className="downLoad_PrintEnqury ">
        <DrivingLicenseDownload
          ref={childRef4}
          downloadForm2={downloadForm}
          SignImg={SignImg}
          DringImg={DlImg}
        />
      </div>
      <div className="reservationHistory">
        <div className="viewStaff_head">
          <div className="row m-0">
            <div className="col-lg-3 col-sm-4 bottomAlgin">
              <div className="inputDiv2">
                <label className="labelPointer" htmlFor="selectFilter">
                  <img src={FilterIcon} alt="Rapid Car Leasing" />
                </label>
                <select
                  id="selectFilter"
                  onChange={handleStatusSelect}
                  value={statusValue}
                >
                  {status_search.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-2 col-sm-4 bottomAlgin">
              <label className="labelView">Start Date</label>
              <div className="person__calenderFrame_image image_icon_position1 ">
                {/* <input
                  id="startDate"
                  type="date"
                  placeholder={ViewStaffPagesText.D_O_B}
                  className="form-control  input_field_custom4"
                  defaultValue={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  dateFormat="MM-dd-yyyy"
                  max={computeTodayDate()}
                /> */}
                <DatePicker
                  selected={startDate}
                  onChange={handleDateChange}
                  className="form-control input_field_custom4"
                  maxDate={computeTodayDate()}
                  dateFormat="MM-dd-yyyy"
                  placeholderText="MM-DD-YYYY"
                />
              </div>
            </div>
            <div className="col-lg-2 col-sm-4 bottomAlgin">
              <label className="labelView">{ViewStaffPagesText.End_Date}</label>
              <div className="person__calenderFrame_image image_icon_position1 ">
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  className="form-control input_field_custom4"
                  maxDate={computeTodayDate()}
                  minDate={startDate}
                  dateFormat="MM-dd-yyyy"
                  placeholderText="MM-DD-YYYY"
                />
              </div>
            </div>
            <div className="col-lg-3 col-sm-4 bottomAlgin hidden">
              <div className="inputDiv2">
                <label className="labelPointer" htmlFor="selectFilter">
                  <img src={FilterIcon} alt="Rapid Car Leasing" />
                </label>
                <select id="selectFilter" onChange={handleSelect}>
                  {options_search.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-5 col-sm-8 bottomAlgin hidden">
              <div className="inputDiv2">
                <img src={Search} alt="Rapid Car Leasing" />
                <input
                  type="text"
                  id="search_data"
                  onInput={(e) => {
                    if (selectedValue === options_search[0].value) {
                      handleAphabetsChange(e);
                    } else if (selectedValue === options_search[1].value) {
                      handleEmailChange(e);
                    } else if (selectedValue === options_search[2].value) {
                      handleNumbersChange(e);
                    }
                  }}
                  placeholder={ViewStaffPagesText.Search_Employee_reservation}
                />
                <button
                  type="button"
                  className="btnSearch"
                  onClick={() => search_data()}
                >
                  {ViewStaffPagesText.Search_text}
                </button>
              </div>
            </div>
            <div
              className="col-lg-3 col-sm-8 bottomAlgin"
              style={{
                marginLeft: "auto",
                marginRight: "0",
              }}
            >
              <div className="mt-2">
                <div className="inputDiv2">
                  <label className="labelPointer" htmlFor="selectFilter">
                    <img src={Search} alt="Rapid Car Leasing" />
                  </label>
                  <input
                    type="text"
                    placeholder={ViewStaffPagesText.Staff_Filter_reservation}
                    onInput={handleIaphabetnumberChange}
                    value={searchfilter}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="reservationHistoryTable">
          <div
            className="historyTableContainer stickyTableheigh274"
            style={{ overflowX: "scroll" }}
          >
            <table
              className="table margin_class_table"
              style={{ minWidth: "max-content", borderCollapse: "collapse" }}
            >
              <thead className="stickyHeaderClss">
                <tr>
                  <th scope="col">Booking ID</th>
                  <th scope="col">Car Info</th>
                  <th scope="col">Driver Details</th>
                  <th scope="col">Status</th>
                  <th scope="col">
                    <img src={Person} alt="Rapid Car Leasing" />
                  </th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              {/* {//console.log("filteredData", filteredData)} */}
              <tbody className="custum_border">
                {currentItems.map((option, index) => (
                  <tr className="historyTableRow" key={index}>
                    <td>
                      <div
                        style={{
                          marginLeft: "0.5rem",
                          fontSize: "14px",
                          marginTop: "1.2rem",
                          fontWeight: "500",
                          color: "var(--medium-text)",
                        }}
                      >
                        #{formatBookingId(option.primary_id)}
                      </div>
                    </td>
                    <td>
                      <div className="topMargin historyTime">
                        <p>{mondayDayYearFormat(option.entry_date)}</p>
                        <div className="historyTimeImgText align-items-start">
                          <img src={TimeTable} alt="Rapid Car Leasing" />
                          <p>
                            {option.car_data &&
                              option.car_data.length > 0 &&
                              option.car_data[0].car_name}
                            (
                            {option.car_data &&
                              option.car_data.length > 0 &&
                              option.car_data[0].car_tagline}
                            )
                            <p>
                              {option.car_data &&
                                option.car_data.length > 0 &&
                                option.car_data[0].car_no}
                            </p>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="historyTableRowText historyName">
                        <h6 className="infoDetalisStats">{option.name} </h6>
                        <p>Contact No.: {option.mobile_no}</p>
                        <p>Email: {option.email}</p>
                      </div>
                    </td>
                    <td>
                      <div className="historyTableRowText historyStatus">
                        {getStatusBadge(option)}
                        <p style={{ padding: "0 15px" }}>
                          Booking Type:{" "}
                          <strong>
                            {" "}
                            {option?.insurance ? option?.insurance : "-"}
                          </strong>
                        </p>
                      </div>
                    </td>
                    <td>
                      <div
                        className="historyTableRowText historyPerson"
                        style={{ flexWrap: "wrap" }}
                      >
                        <div>
                          <IdCard className="tble_icon" strokeWidth={1.5} />
                          <p>Licence No: {option.driving_licence}</p>
                        </div>
                        <div>
                          <CalendarClock
                            className="tble_icon"
                            strokeWidth={1.5}
                          />
                          <p>
                            Expiry date:{" "}
                            {option.driving_expiration_date == null ? (
                              <></>
                            ) : (
                              <>
                                {mondayDayYearFormat(
                                  option.driving_expiration_date,
                                )}
                              </>
                            )}
                          </p>
                        </div>
                        <div>
                          <ParkingMeter
                            className="tble_icon"
                            strokeWidth={1.5}
                          />
                          <p>
                            PickUp Date: {mondayDayYearFormat(option.from_date)}
                          </p>
                        </div>
                        <div>
                          <Clock className="tble_icon" strokeWidth={1.5} />
                          <p>
                            PickUp Time:{" "}
                            {formatTimeTo24Hour(option.new_from_time)}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        className="historyActionsBtns mb-2"
                        style={{ maxWidth: "480px" }}
                      >
                        <div className="Action_booking_btn">
                          {option.step_for_booking >= "3" &&
                            option.step_for_booking < "9" && (
                              <Button
                                className="instructions Add_Instructions"
                                title="Download Agreement"
                                style={{ cursor: "pointer" }}
                                onClick={() => triggerDownloadPDF2(option)}
                              >
                                Agreement <Download size={16} />
                              </Button>
                            )}

                          {option.step_for_booking >= "2" && (
                            <>
                              {option.office_use_status == "1" ? (
                                <Button
                                  className="instructions Add_Instructions"
                                  style={{
                                    whiteSpace: "nowrap",
                                    width: "fit-content",
                                  }}
                                  onClick={() =>
                                    handleNavigateEditPage(
                                      option.primary_id,
                                      option,
                                    )
                                  }
                                  title="Complete Office Use Form"
                                >
                                  Office Use <ClipboardEdit size={16} />
                                </Button>
                              ) : (
                                <>
                                  {/* {option.step_for_booking < "5" && (
                                    <Button
                                      className="instructions Add_Instructions"
                                      onClick={() =>
                                        handleNavigateEditPage(
                                          option.primary_id,
                                          option
                                        )
                                      }
                                      // title="Complete Office Use Form"
                                    >
                                      Edit <Edit size={16} />
                                    </Button>
                                  )} */}
                                </>
                              )}
                            </>
                          )}

                          {option.step_for_booking === "0" && (
                            <Button
                              className="instructions Add_Instructions"
                              onClick={() => handleShow(option, "review")}
                              title="Review Application"
                            >
                              Review <FileText size={16} />
                            </Button>
                          )}

                          {option.step_for_booking === "1" && (
                            <Button
                              className="instructions Add_Instructions"
                              onClick={() => handleShow(option, "policy")}
                              style={{
                                whiteSpace: "nowrap",
                                width: "fit-content",
                              }}
                            >
                              Update Policy Number <ShieldCheck size={16} />
                            </Button>
                          )}

                          {option.step_for_booking === "3" &&
                            option.fill_aggriment_status == 1 && (
                              <Button
                                className="instructions Add_Instructions"
                                onClick={() =>
                                  navigate(`/PickUpForm/${option.primary_id}`)
                                }
                              >
                                Handover <Key className="key_icon" size={16} />
                              </Button>
                            )}
                          {parseInt(option.step_for_booking) >= 1 &&
                            parseInt(option.step_for_booking) <= 3 && (
                              <Button
                                className="Add_Instructions booking_cancelBtnas"
                                onClick={() =>
                                  handleModalSHowCancel(option.primary_id)
                                }
                              >
                                Cancel Booking
                              </Button>
                            )}
                          {parseInt(option.step_for_booking) >= 9 && (
                            <Button
                              className="instructions Add_Instructions"
                              title="Archive this booking"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleModalSHowArchive(
                                  option.primary_id,
                                  option.show_hide_status,
                                )
                              }
                            >
                              Archive <ArchiveRestore size={16} />
                            </Button>
                          )}
                          {/* </div>

                        <div className="Action_booking_btn"> */}
                          {option.step_for_booking === "4" && (
                            <>
                              <Button
                                className="instructions Add_Instructions"
                                onClick={() => openModal(option)}
                              >
                                Drop Car <CalendarCheck size={16} />
                              </Button>
                              <Button
                                className="instructions Add_Instructions"
                                title=" Switch I-Pass"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleOpenIpassModal(option)}
                              >
                                Switch I-Pass
                              </Button>
                              <Button
                                className="instructions Add_Instructions"
                                title="CHange Payment Cycle"
                                style={{ cursor: "pointer" }}
                                onClick={() => HandlePaymentCycleModal(option)}
                              >
                                Payment Cycle
                              </Button>
                            </>
                          )}
                          {option.step_for_booking === "7" && (
                            <>
                              <Button
                                className="instructions Add_Instructions"
                                onClick={() =>
                                  navigate(`/DropOfForm/${option.primary_id}`)
                                }
                              >
                                Drop Car <CalendarCheck size={16} />
                              </Button>
                            </>
                          )}

                          {(option.step_for_booking === "4" ||
                            option.step_for_booking === "5" ||
                            option.step_for_booking === "6") && (
                            <Button
                              className="instructions Add_Instructions"
                              onClick={() =>
                                handleNavigateViewPage(
                                  "/PickupFormPreview",
                                  option,
                                )
                              }
                            >
                              View Pickup <Eye size={16} />
                            </Button>
                          )}
                          {option.step_for_booking === "7" && (
                            <Button
                              className="instructions Add_Instructions"
                              onClick={() =>
                                handleNavigateViewPage("/ViewRepo", option)
                              }
                            >
                              View Repo <Eye size={16} />
                            </Button>
                          )}

                          {(option.step_for_booking == "5" ||
                            option.step_for_booking === "6") && (
                            <>
                              <Button
                                className="instructions Add_Instructions"
                                onClick={() =>
                                  handleNavigateViewPage(
                                    "/DropoffFormPreview",
                                    option,
                                  )
                                }
                              >
                                View Drop <Eye size={16} />
                              </Button>
                            </>
                          )}
                          {option.step_for_booking === "6" &&
                            option.switch_car_status == 0 && (
                              <>
                                <Button
                                  className="instructions Add_Instructions"
                                  onClick={() =>
                                    handleNavigateViewPage(
                                      `/Create_WalkInSwitch/${option.primary_id}`,
                                    )
                                  }
                                >
                                  Switch Car <Eye size={16} />
                                </Button>
                              </>
                            )}
                          <Link to="/WeeklyReport" state={{ option: option }}>
                            <Button className="instructions Add_Instructions">
                              View Report <File size={16} />
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
                {currentItems.length === 0 && (
                  <tr>
                    <td colSpan={5} className="text_align_center">
                      No Results Found
                    </td>{" "}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="cust_hist_card_footer">
            <div className="cust_hist_pagination_info">
              {SearchFilter && SearchFilter.length > 0 ? (
                <>
                  Showing{" "}
                  <span className="cust_hist_pagination_bold">
                    {indexOfFirstItem + 1}
                  </span>{" "}
                  to{" "}
                  <span className="cust_hist_pagination_bold">
                    {Math.min(indexOfLastItem, SearchFilter.length)}
                  </span>{" "}
                  of{" "}
                  <span className="cust_hist_pagination_bold">
                    {SearchFilter.length}
                  </span>{" "}
                  rentals
                </>
              ) : (
                <>
                  Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                  rentals
                </>
              )}
            </div>
            <div className="cust_hist_pagination">
              <nav aria-label="Pagination">
                <ul className="cust_hist_pagination_list">
                  {renderPaginationButtons()}
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <CarActionModalPopup
          isOpen={isModalOpen}
          onClose={closeModal}
          onAction={(action) => {
            if (action === "drop" && selectedItem) {
              navigate(`/DropOfForm/${selectedItem.primary_id}`);
            } else if (action === "switch") {
              navigate(`/SwitchForm/${selectedItem.primary_id}`);
            } else if (action === "repo") {
              navigate(`/Repo-Form`, { state: { option: selectedItem } });
            }
          }}
        />

        {/*--------- Review Modal------------------ */}
        <ReviewModal
          modalShow={modalShow}
          avaliblecar={avaliblecar}
          handleClose={handleClose}
          SelectedData={SelectedData}
          APL_LINK={APL_LINK}
          DringImg={DringImg}
          activeAgree={activeAgree}
          handleuploadMvrFile={handleuploadMvrFile}
          handleuploadDLFile={handleuploadDLFile}
          handleuploadDLFileMVR={handleuploadDLFileMVR}
          setActiveAgree={setActiveAgree}
          toggleActiveAgree={toggleActiveAgree}
          handleActiveDeactive={handleActiveDeactive}
          triggerDownloadPDF={triggerDownloadPDF}
          triggerDownloadMVR={triggerDownloadMVR}
          triggerDownloadDL={triggerDownloadDL}
          setUploadedDamageImagesfinal={setUploadedDamageImages}
        />
        {/**---------Update policy Modal---------- */}
        <UpdatePolicyModal
          modalShow1={modalShow1}
          handleClose={handleClose}
          SelectedData={SelectedData}
          activeAgree1={activeAgree1}
          DringImg={DringImg}
          handleActiveDeactive={handleActiveDeactive}
          triggerDownloadPDF={triggerDownloadPDF}
          openCustomDatePicker={openCustomDatePicker}
          APL_LINK={APL_LINK}
        />
        <SwitchIPassModal
          show={showIpassModal}
          onHide={handleCloseIpassModal}
          currentIPass={dummyCurrentIPass}
          availableIPasses={dummyAvailableIPasses}
          onSwitchComplete={handleSwitchComplete}
          master_data_get={search_data}
          carData={ipasscarData}
          carIpass={carIpass}
          totalIpass={totalIpass}
        />
      </div>

      {/* Cancel Booking COnfirmation Modal */}
      <Modal
        className="statusModal"
        backdrop="static"
        centered
        size="md"
        show={showModal}
        onHide={cancelToggleStatus}
      >
        <Modal.Body>
          <div className="statusContntDiv">
            {" "}
            <div className="d-flex flex-column align-items-center gap-3">
              <img src={UserIconOrenge} alt="UserIconOrenge"></img>
              <p>Are you sure you want to cancel this booking</p>
              <div className="StatusDecideBttn">
                <button
                  className="yesBtnStasus"
                  onClick={() => handlecancelbooking(id)}
                >
                  Yes
                </button>
                <button className="noBtnStsus" onClick={cancelToggleStatus}>
                  No
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Archive Booking COnfirmation Modal */}
      <Modal
        className="statusModal"
        backdrop="static"
        centered
        size="md"
        show={showModalArchive}
        onHide={cancelToggleStatus}
      >
        <Modal.Body>
          <div className="statusContntDiv">
            {" "}
            <div className="d-flex flex-column align-items-center gap-3">
              <img src={UserIconOrenge} alt="UserIconOrenge"></img>
              <p>
                Are you sure you want to Archive this booking, You won't be able
                to change this again!
              </p>
              <div className="StatusDecideBttn">
                <button
                  className="yesBtnStasus"
                  onClick={() => handleArchivebooking(idArchive, archiveState)}
                >
                  Yes
                </button>
                <button className="noBtnStsus" onClick={cancelToggleStatus}>
                  No
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Past Dues Reminder Modal */}
      <Modal
        className="statusModal"
        backdrop="static"
        centered
        size="md"
        show={dueModal}
        onHide={cancelToggleStatus}
      >
        <Modal.Body>
          <div className="statusContntDiv">
            {" "}
            <div className="d-flex flex-column align-items-center gap-3">
              <img src={UserIconOrenge} alt="UserIconOrenge"></img>
              <p className="px-3">{duescontnt}</p>
              <div className="StatusDecideBttn">
                <button
                  className="yesBtnStasus"
                  onClick={() => handleArchivebooking2(idArchive, archiveState)}
                >
                  Yes
                </button>
                <button className="noBtnStsus" onClick={cancelToggleStatus}>
                  No
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Payment Cycle Modal */}
      <Modal
        show={PaymentCycleModal}
        className="TransactionModal"
        centered
        onHide={() => handleClosePaymentCycleModal()}
        size="container-lg"
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "var(--primary-color)" }}
        >
          <Modal.Title style={{ color: "#fff" }}>
            Choose Payment Cycle
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="car-action-buttons" style={{ padding: "16px" }}>
            <form>
              <label
                htmlFor="daily"
                className="car-action-btn car-action-repo"
                style={{
                  marginBottom: "10px",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "flex-start",
                  cursor: "pointer", // Add cursor pointer for better UX
                }}
              >
                <input
                  type="radio"
                  id="daily"
                  name="paymentCycle"
                  value="Daily"
                  checked={SelectedCycle === "Daily"}
                  onChange={(e) => setSelectedCycle(e.target.value)}
                />
                <span style={{ marginLeft: "8px" }}>Daily</span>
              </label>

              <label
                htmlFor="weekly"
                className="car-action-btn car-action-switch"
                style={{
                  marginBottom: "10px",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "flex-start",
                  cursor: "pointer", // Add cursor pointer for better UX
                }}
              >
                <input
                  type="radio"
                  id="weekly"
                  name="paymentCycle"
                  value="Weekly"
                  checked={SelectedCycle === "Weekly"}
                  onChange={(e) => setSelectedCycle(e.target.value)}
                />
                <span style={{ marginLeft: "8px" }}>Weekly</span>
              </label>
            </form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn"
            style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}
            onClick={() => {
              handleConfirm();
              // setPaymentCycleModal(false);
            }}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ReservationHistory;
